import { useState, type ReactNode } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';

/** L13.02 — New Billing Claim: vendor creates a new billing claim. */
export function VendorBillingNewPage(): ReactNode {
  const { token } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const jobId = params.get('jobId') ?? '';
  const [form, setForm] = useState({ billingPeriodFrom: '', billingPeriodTo: '', remarks: '' });
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleCreate = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const r = await apiRequest<any>('/v1/vendor/billing/claims', { token, method: 'POST', body: { billingPeriodFrom: form.billingPeriodFrom, billingPeriodTo: form.billingPeriodTo, remarks: form.remarks || undefined } });
      setResult(r);
    } catch (e) { setError((e as Error).message); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ padding: 24, maxWidth: 500 }}>
      <h1>New Billing Claim</h1>
      {jobId && <p>Job: <strong>{jobId}</strong></p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {result ? (
        <div style={{ padding: 16, background: '#dafbe1', borderRadius: 6 }}>
          <p>Claim created: <strong>{result.claimNumber}</strong></p>
          <button onClick={() => navigate(`/vendor/portal/billing/${result.claimId}`)} style={{ padding: '6px 16px', background: '#0969da', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>View Claim</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label>Billing Period From:<br /><input type="date" value={form.billingPeriodFrom} onChange={e => setForm({ ...form, billingPeriodFrom: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #d0d7de' }} /></label>
          <label>Billing Period To:<br /><input type="date" value={form.billingPeriodTo} onChange={e => setForm({ ...form, billingPeriodTo: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #d0d7de' }} /></label>
          <label>Remarks (optional):<br /><textarea value={form.remarks} onChange={e => setForm({ ...form, remarks: e.target.value })} style={{ width: '100%', height: 60, padding: 6, borderRadius: 4, border: '1px solid #d0d7de' }} /></label>
          <button onClick={handleCreate} disabled={submitting || !form.billingPeriodFrom || !form.billingPeriodTo} style={{ padding: '8px 24px', background: '#1a7f37', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', opacity: submitting ? 0.6 : 1 }}>{submitting ? 'Creating...' : 'Create Claim'}</button>
        </div>
      )}
    </div>
  );
}
